import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { useQueryParams, makeQueryStrings } from '../../utils/queryParams';
import { LAYOUT_TYPES, BASENAME } from '../../constants';
import { setLayoutType } from '../../modules/app';
import LinkButton from '../atoms/button/LinkButton';

const Error = ({ title, descHTML, linkUrl, buttonText }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setLayoutType(LAYOUT_TYPES.error)
    );
    return () => {
      dispatch(
        setLayoutType(LAYOUT_TYPES.default)
      );
    };
  }, []);

  return (
    <div className="errorPage">
      <div className="errorTitle">{title}</div>
      <div className="errorText" dangerouslySetInnerHTML={{ __html: descHTML }} />
      <div className="errorButton">
        <a href={`${BASENAME}${linkUrl}`}>
          <LinkButton buttonType="primary">{buttonText}</LinkButton>
        </a>
      </div>
    </div>
  );
};

Error.defaultProps = {
  title: 'お探しのページは見つかりませんでした',
  descHTML: '申し訳ありません。お探しのページは見つかりませんでした。<br />お手数おかけいたしますが、TOPページから再度お探しください。',
  linkUrl: '/search',
  buttonText: 'TOPページに戻る',
};

Error.propTypes = {
  title: PropTypes.string,
  descHTML: PropTypes.string,
  linkUrl: PropTypes.string,
  buttonText: PropTypes.string,
};

export default Error;

export const DynamicError = () => {
  const query = useQueryParams();
  const { m: message } = query;

  return (
    <Error title="エラーが発生しました" descHTML={message} />
  );
};
